import { SymbolEventColumn } from 'widgets/corpActions/widget/grid/columnDefinitions';
import { GridDetailsPanelColumnDef } from 'utils/components/GridDetailsPanel/gridDetailsPanelColumnDef';

const listingChange: GridDetailsPanelColumnDef<SymbolEventColumn>[] = [
    {
        controls: [
            { type: 'field', field: 'oldExch' },
            { type: 'field', field: 'exDate' },
        ],
    },
    {
        controls: [{ type: 'field', field: 'newExch' }],
    },
];

export default listingChange;
